module.exports = __webpack_public_path__ + "img/C05TechMarianReformation_ua.81636658.webp";